export default "__VITE_ASSET__b5a0764a__"